import { render, staticRenderFns } from "./DsfrCallout.vue?vue&type=template&id=e5fc74f6&scoped=true&"
import script from "./DsfrCallout.vue?vue&type=script&lang=js&"
export * from "./DsfrCallout.vue?vue&type=script&lang=js&"
import style0 from "./DsfrCallout.vue?vue&type=style&index=0&id=e5fc74f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fc74f6",
  null
  
)

export default component.exports